/** Feature discovery key for the custom lead capture form education touchpoints. */
export const CUSTOM_LEAD_FORM_EDUCATION = 'CUSTOM_LEAD_FORM_EDUCATION';

/** Feature discovery key for the list enrichment nav link. */
export const LIST_ENRICHMENT_DISCOVERY = 'LIST_ENRICHMENT_DISCOVERY';
